import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const RulesPage = () => {
  const { t } = useTranslation(["rules"]);

  return (
    <motion.div
      className="z-1 relative flex w-full max-w-lg flex-col"
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0 }}
      transition={{ duration: 0.2, type: "spring", mass: 1 }}
    >
      <div className="mt-4 space-y-3 px-2 text-justify md:px-0">
        <h3 className="mb-3 text-xl font-bold">{t("How to play")}</h3>
        <div className="mb-3 space-y-3 border-b-2 border-slate-200 pb-3 text-justify">
          <div>
            {t("Attempt to guess the")}
            <span className="mx-1 font-bold">WORLDLE</span>
            {t("within six attempts.")}
          </div>
          <div>
            {t(
              "Every attempt should be a recognized sovereign state or dependent territory.",
            )}
          </div>
          <div>
            {t(
              "Following each attempt, you will receive information about the closeness of your guess to the target position, including the distance, direction, and proximity.",
            )}
          </div>
        </div>
        <div className="mb-3 space-y-3 border-b-2 border-slate-200 pb-3 text-justify">
          <div className="font-bold">{t("Examples")}</div>
          <div>
            <div>
              <div className="grid grid-cols-7 gap-1 text-center">
                <div className="animate-reveal col-span-3 flex h-8 items-center justify-center rounded border-2">
                  <p className="overflow-hidden text-ellipsis whitespace-nowrap">
                    {t("Germany")}
                  </p>
                </div>
                <div className="animate-reveal col-span-2 flex h-8 items-center justify-center rounded border-2">
                  1,557km
                </div>
                <div className="animate-reveal col-span-1 flex h-8 items-center justify-center rounded border-2">
                  <span>
                    <img
                      alt="↗️"
                      src="/images/2197.png"
                      className="m-0.125 mr-0.25 mb-0.125 mt-0.1 h-4 w-4"
                    />
                  </span>
                </div>
                <div className="animate-reveal animate-pop col-span-1 flex h-8 items-center justify-center rounded border-2">
                  32%
                </div>
              </div>
            </div>
            <div className="my-2">
              {t("Your guess")}
              <span className="mx-1 font-bold uppercase">{t("Germany")}</span>
              {t(
                "lies approximately 1,557 kilometers away from the target location. Despite being in the North-East direction, your proximity is only 32%, indicating it's quite far away!",
              )}
            </div>
          </div>
          <div>
            <div>
              <div className="grid grid-cols-7 gap-1 text-center">
                <div className="animate-reveal col-span-3 flex h-8 items-center justify-center rounded border-2">
                  <p className="overflow-hidden text-ellipsis whitespace-nowrap">
                    {t("Iceland")}
                  </p>
                </div>
                <div className="animate-reveal col-span-2 flex h-8 items-center justify-center rounded border-2">
                  102km
                </div>
                <div className="animate-reveal col-span-1 flex h-8 items-center justify-center rounded border-2">
                  <span>
                    <img
                      alt="↘️"
                      src="/images/2198.png"
                      className="m-0.125 mr-0.25 mb-0.125 mt-0.1 h-4 w-4"
                    />
                  </span>
                </div>
                <div className="animate-reveal animate-pop col-span-1 flex h-8 items-center justify-center rounded border-2">
                  14%
                </div>
              </div>
            </div>
            <div className="my-2">
              {t("Your second guess") + " "}
              <span className="font-bold uppercase">{t("Iceland")}</span>
              {" " +
                t(
                  "brings you closer, with a distance of 102 kilometers. It's situated in the South-East direction, though your proximity is now at 14%.",
                )}
            </div>
          </div>
          <div>
            <div>
              <div className="grid grid-cols-7 gap-1 text-center">
                <div className="animate-reveal col-span-3 flex h-8 items-center justify-center rounded border-2">
                  <p className="overflow-hidden text-ellipsis whitespace-nowrap">
                    {t("Egypt")}
                  </p>
                </div>
                <div className="animate-reveal col-span-2 flex h-8 items-center justify-center rounded border-2">
                  0km
                </div>
                <div className="animate-reveal col-span-1 flex h-8 items-center justify-center rounded border-2">
                  <span>
                    <img
                      alt="🎉"
                      src="/images/1f389.png"
                      className="m-0.125 mr-0.25 mb-0.125 mt-0.1 h-4 w-4"
                    />
                  </span>
                </div>
                <div className="animate-reveal animate-pop col-span-1 flex h-8 items-center justify-center rounded border-2">
                  100%
                </div>
              </div>
            </div>
            <div className="my-2">
              {t("Finally, your intuition guides you to ")}
              <span className="font-bold uppercase">{t("Egypt")}</span>
              {t(", the correct location! Congratulations!")}
              <span>
                <img
                  alt="🎉"
                  src="/images/1f389.png"
                  className="m-0.125 mr-0.25 mb-0.125 mt-0.1 inline-block h-4 w-4"
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default RulesPage;
